function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.1278 120.367C62.2213 120.367 60.6846 118.822 60.6846 116.924V101.146C60.6846 95.3853 65.3687 90.7094 71.1212 90.7094H97.9851C103.746 90.7094 108.422 95.3935 108.422 101.146V111.213C108.422 113.119 106.877 114.656 104.978 114.656C103.072 114.656 101.535 113.111 101.535 111.213V101.146C101.535 99.1901 99.9409 97.5959 97.9851 97.5959H71.1212C69.1653 97.5959 67.5711 99.1901 67.5711 101.146V116.924C67.5711 118.822 66.0261 120.367 64.1278 120.367Z",
  fill: "#275183"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M235.683 120.367C233.776 120.367 232.239 118.822 232.239 116.924V101.146C232.239 99.1901 230.645 97.5959 228.689 97.5959H201.825C199.869 97.5959 198.275 99.1901 198.275 101.146V111.213C198.275 113.119 196.73 114.656 194.832 114.656C192.925 114.656 191.389 113.111 191.389 111.213V101.146C191.389 95.3853 196.073 90.7094 201.825 90.7094H228.689C234.45 90.7094 239.126 95.3935 239.126 101.146V116.924C239.126 118.822 237.589 120.367 235.683 120.367Z",
  fill: "#275183"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M232.362 112.191H67.448C56.6991 112.191 47.9883 120.902 47.9883 131.65V149.056H251.814V131.65C251.822 120.902 243.111 112.191 232.362 112.191Z",
  fill: "#75B0FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "body",
  d: "M149.79 53.4582L113.55 71.751C108.767 74.167 104.757 77.9308 102.201 82.6396C97.073 92.0818 93.0955 101.918 90.4905 112.232C89.603 126.646 98.3714 129.76 110.567 127.805L111.429 138.8H188.142L189.005 127.805C201.209 129.76 209.969 126.646 209.081 112.232C206.468 101.918 202.491 92.0818 197.371 82.6396C194.815 77.9308 190.805 74.167 186.022 71.751L149.79 53.4582Z",
  fill: "#2A7771"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "leg",
  d: "M98.3547 156.254H66.2725L71.1292 119.817C72.0742 112.708 78.1389 107.4 85.3131 107.4H88.518C97.1713 107.4 103.844 115.017 102.702 123.597L98.3547 156.254Z",
  fill: "#3CA19D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "leg",
  d: "M201.454 156.254H233.537L228.68 119.817C227.735 112.708 221.67 107.4 214.496 107.4H211.291C202.638 107.4 195.965 115.017 197.107 123.597L201.454 156.254Z",
  fill: "#3CA19D"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.976 74.1259C137.275 73.9615 135.639 73.452 134.177 72.6385C133.223 72.1125 132.336 71.4551 131.555 70.6826C131.161 70.3046 130.799 69.8937 130.462 69.4582C127.783 66.0067 124.093 59.2353 121.529 54.1978C120.798 52.7597 120.173 51.0832 119.639 49.2589C118.53 45.4787 117.84 41.0986 117.568 37.1294C117.478 35.8228 117.429 34.549 117.429 33.3657C117.429 29.6841 118.037 26.1505 119.171 22.8551C122.672 12.624 131.12 4.71027 141.663 1.95731C142.559 1.719 143.471 1.52177 144.399 1.36563C145.624 1.15197 146.873 1.01227 148.147 0.954741C148.656 0.92187 149.166 0.905436 149.683 0.905436C149.741 0.897219 149.799 0.897217 149.856 0.897217H149.946C150.004 0.897217 150.061 0.897219 150.119 0.905436C150.637 0.905436 151.146 0.92187 151.656 0.954741C152.93 1.01227 154.179 1.15197 155.403 1.36563C156.332 1.52177 157.244 1.719 158.14 1.95731C168.691 4.71027 177.131 12.6322 180.632 22.8551C181.766 26.1505 182.374 29.6841 182.374 33.3657C182.374 34.549 182.325 35.8228 182.234 37.1294C181.963 41.1068 181.273 45.4869 180.163 49.2589C179.629 51.0832 179.005 52.7597 178.273 54.1978C175.709 59.2435 172.019 66.0067 169.34 69.4582C169.003 69.8937 168.642 70.3046 168.247 70.6826C167.467 71.4551 166.579 72.1125 165.626 72.6385C164.163 73.452 162.528 73.9615 160.827 74.1259H138.976Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "mask",
  d: "M149.905 55.1182C149.042 55.1182 148.179 55.3154 147.406 55.6934L147.086 55.8496C144.793 56.9672 142.237 57.5589 139.69 57.5589C138.252 57.5589 136.822 57.3781 135.433 57.0165L133.987 56.6385C127.191 54.8634 121.972 49.5301 120.386 42.7176C119.532 39.0606 119.285 35.4695 119.655 32.0344C119.918 29.602 121.939 27.7694 124.355 27.7694C124.651 27.7694 124.947 27.7941 125.243 27.8516C134.209 29.5691 141.588 30.3005 149.905 30.3005C158.221 30.3005 165.601 29.5609 174.566 27.8516C174.862 27.7941 175.158 27.7694 175.454 27.7694C177.87 27.7694 179.891 29.602 180.154 32.0344C180.524 35.4613 180.277 39.0606 179.423 42.7176C177.829 49.5301 172.619 54.8634 165.822 56.6385L164.376 57.0165C162.987 57.3781 161.557 57.5589 160.119 57.5589C157.572 57.5589 155.016 56.9672 152.723 55.8496L152.403 55.6934C151.63 55.3236 150.767 55.1182 149.905 55.1182Z",
  fill: "#155B56"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.904 52.6528C148.68 52.6528 147.456 52.9322 146.33 53.4828L146.009 53.6389C142.919 55.151 139.386 55.5044 136.058 54.6333L134.611 54.2553C128.735 52.7185 124.166 48.0673 122.786 42.1587C122.03 38.9373 121.75 35.568 122.104 32.3055C122.243 30.9743 123.468 30.0292 124.783 30.284C133.641 31.9768 141.292 32.774 149.904 32.7822C158.517 32.7822 166.167 31.9851 175.026 30.284C176.341 30.0292 177.557 30.9825 177.705 32.3055C178.059 35.568 177.771 38.9455 177.023 42.1587C175.643 48.0755 171.073 52.7185 165.198 54.2553L163.751 54.6333C160.423 55.5044 156.89 55.151 153.8 53.6389L153.479 53.4828C152.353 52.9322 151.129 52.6528 149.904 52.6528Z",
  fill: "#A5CDFF"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.389 32.4206L128.35 48.8562C129.271 49.7683 130.306 50.5572 131.44 51.1982L130.339 32.8972C129.369 32.7575 128.383 32.5932 127.389 32.4206Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.785 33.111L132.969 51.9543C133.634 52.2337 134.316 52.4803 135.031 52.6611L136.477 53.0391C137.529 53.3103 138.614 53.45 139.699 53.45C140.126 53.45 140.545 53.4171 140.973 53.376L140.233 34.0313C137.447 33.8259 134.661 33.5219 131.785 33.111Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176.07 32.4782C176.037 32.1413 175.766 31.8865 175.453 31.8865C175.412 31.8865 175.379 31.8865 175.338 31.8947C174.73 32.0098 174.139 32.1166 173.539 32.2235L173.013 47.0566C174.139 45.5034 174.969 43.7201 175.42 41.789C176.16 38.6251 176.382 35.4037 176.07 32.4782Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "helmet",
  d: "M141.671 1.95728V22.7236C141.671 24.7698 139.896 26.3805 137.858 26.1751C130.766 25.4683 125.621 24.4247 119.179 22.8551C122.671 12.6322 131.119 4.71023 141.671 1.95728Z",
  fill: "#3CA19D"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "helmet",
  d: "M158.14 1.95728V22.7236C158.14 24.7698 159.915 26.3805 161.953 26.1751C169.045 25.4683 174.189 24.4247 180.632 22.8551C177.139 12.6322 168.691 4.71023 158.14 1.95728Z",
  fill: "#3CA19D"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "mask",
  d: "M149.888 26.5038C148.927 26.5038 148.154 25.7231 148.154 24.7699V2.63939C148.154 1.68613 148.919 0.905435 149.864 0.897217C149.88 0.897217 149.896 0.897217 149.905 0.897217C149.921 0.897217 149.938 0.897217 149.946 0.897217C150.899 0.897217 151.655 1.68613 151.655 2.63939V24.7699C151.655 25.7313 150.874 26.5038 149.921 26.5038H149.888Z",
  fill: "#155B56"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "helmet",
  d: "M138.976 74.1259C137.275 73.9615 135.64 73.452 134.177 72.6385C137.727 65.1356 143.438 58.7175 149.906 58.6518C156.373 58.7175 162.084 65.1438 165.634 72.6385C164.172 73.452 162.536 73.9615 160.835 74.1259H138.976Z",
  fill: "#3CA19D"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "helmet",
  d: "M136.781 62.547C134.735 64.9137 132.984 67.7077 131.554 70.6908C131.16 70.3128 130.798 69.9019 130.461 69.4664C127.782 66.0149 124.093 59.2434 121.529 54.2059C120.797 52.7678 120.173 51.0914 119.639 49.267C123.189 56.0221 129.804 59.4653 135.787 60.0652C137.027 60.1803 137.595 61.6101 136.781 62.547Z",
  fill: "#3CA19D"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "helmet",
  d: "M163.029 62.547C165.075 64.9137 166.825 67.7077 168.255 70.6908C168.649 70.3128 169.011 69.9019 169.348 69.4664C172.027 66.0149 175.717 59.2434 178.281 54.2059C179.012 52.7678 179.637 51.0914 180.171 49.267C176.621 56.0221 170.005 59.4653 164.023 60.0652C162.782 60.1803 162.215 61.6101 163.029 62.547Z",
  fill: "#3CA19D"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "body-shadow",
  d: "M109.046 91.8681L96.5137 109.043C100.516 98.3026 104.682 87.94 112.21 85.0884L121.964 81.6287L109.046 91.8681Z",
  fill: "#155B56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "body-shadow",
  d: "M190.788 91.8681L203.321 109.043C199.319 98.3026 195.152 87.94 187.625 85.0884L177.87 81.6287L190.788 91.8681Z",
  fill: "#155B56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.1169 190.243H16.8836C13.9663 190.243 11.5996 187.876 11.5996 184.959V123.531C11.5996 120.614 13.9663 118.247 16.8836 118.247H47.1169C50.0342 118.247 52.4009 120.614 52.4009 123.531V184.959C52.4009 187.876 50.0342 190.243 47.1169 190.243Z",
  fill: "#275183"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M281.546 190.243H251.312C248.395 190.243 246.028 187.876 246.028 184.959V123.531C246.028 120.614 248.395 118.247 251.312 118.247H281.546C284.463 118.247 286.83 120.614 286.83 123.531V184.959C286.83 187.876 284.463 190.243 281.546 190.243Z",
  fill: "#275183"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289.27 139.852H232.74L228.114 133.376C223.298 126.637 215.524 122.635 207.24 122.635H92.5777C84.2942 122.635 76.5202 126.637 71.7045 133.376L67.0779 139.852H9.16719C3.11069 139.852 -1.03929 145.957 1.18772 151.587L2.6094 155.186C7.99205 168.795 21.1405 177.736 35.7764 177.736H262.645C277.281 177.736 290.429 168.795 295.812 155.186L297.233 151.587C299.469 145.957 295.319 139.852 289.27 139.852Z",
  fill: "white"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M288.374 149.047L287.273 151.8C283.254 161.974 273.607 168.54 262.652 168.54H35.7842C24.8545 168.54 15.1822 161.974 11.1637 151.8L10.0625 149.047H71.7945L79.1658 138.709C79.8561 137.748 80.6368 136.869 81.5079 136.113C84.5156 133.376 88.4437 131.815 92.5772 131.815H207.224C212.532 131.815 217.537 134.387 220.635 138.701L228.006 149.039H288.374V149.047Z",
  fill: "#75B0FF"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.607 161.448L71.7952 149.047L70.0283 137.764C70.7186 136.803 78.9364 135.685 79.8075 134.921L116.607 161.448Z",
  fill: "white"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.203 161.448L228.015 149.047L227.587 138.2C226.897 137.238 221.087 135.463 220.208 134.707L183.203 161.448Z",
  fill: "white"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.906 123.827C131.481 123.827 116.492 110.966 116.492 95.1634C116.492 79.3605 131.481 66.4997 149.906 66.4997C168.33 66.4997 183.319 79.3605 183.319 95.1634C183.319 110.974 168.33 123.827 149.906 123.827ZM149.906 75.6954C136.544 75.6954 125.68 84.4309 125.68 95.1716C125.68 105.912 136.544 114.648 149.906 114.648C163.268 114.648 174.132 105.912 174.132 95.1716C174.132 84.4309 163.268 75.6954 149.906 75.6954Z",
  fill: "#275183"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "hand",
  d: "M120.354 82.6066C122.318 85.7623 126.698 88.8604 129.517 84.6611C133.009 89.0083 129.944 91.8106 129.517 94.5389C129.319 95.7797 129.122 97.0288 128.925 98.2697C128.859 98.7053 128.785 99.149 128.621 99.5599C128.152 100.727 127.076 102.19 125.917 102.674C124.134 103.422 122.211 103.751 120.304 104.071C118.842 104.318 117.264 103.841 115.809 103.595C114.535 103.381 113.352 102.79 112.103 102.444C110.854 102.099 106.178 93.3719 111.281 86.2225C112.317 84.7679 114.889 82.1629 116.245 80.996C117.995 79.5003 120.6 78.8347 122.852 78.3416C122.153 79.3031 120.115 81.8835 120.165 82.1958C120.206 82.3519 120.28 82.4834 120.354 82.6066Z",
  fill: "#3CA19D"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  className: "hand",
  d: "M179.481 82.6066C177.517 85.7623 173.137 88.8604 170.319 84.6611C166.826 89.0083 169.891 91.8106 170.319 94.5389C170.516 95.7797 170.713 97.0288 170.91 98.2697C170.976 98.7053 171.05 99.149 171.214 99.5599C171.683 100.727 172.759 102.19 173.918 102.674C175.701 103.422 177.624 103.751 179.531 104.071C180.994 104.318 182.571 103.841 184.026 103.595C185.3 103.381 186.483 102.79 187.732 102.444C188.981 102.099 193.657 93.3719 188.554 86.2225C187.518 84.7679 184.946 82.1629 183.59 80.996C181.84 79.5003 179.235 78.8347 176.983 78.3416C177.682 79.3031 179.72 81.8835 179.67 82.1958C179.629 82.3519 179.555 82.4834 179.481 82.6066Z",
  fill: "#3CA19D"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M106.622 143.714H193.188L172.751 86.9538C171.789 84.283 169.25 82.4998 166.406 82.4998H133.396C130.552 82.4998 128.013 84.283 127.051 86.9538L106.622 143.714Z",
  fill: "#75B0FF"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.062 115.059C173.399 113.933 173.062 113.111 171.46 113.111H166.151C164.803 113.111 164.179 113.826 163.842 114.615C163.842 114.615 161.138 121.197 157.317 125.471C156.076 126.711 155.517 127.106 154.843 127.106C154.506 127.106 154.022 126.711 154.022 125.586V115.067C154.022 113.719 153.627 113.119 152.501 113.119H144.16C143.314 113.119 142.813 113.744 142.813 114.344C142.813 115.626 144.727 115.922 144.925 119.521V127.336C144.925 129.054 144.612 129.358 143.938 129.358C142.139 129.358 137.759 122.75 135.162 115.182C134.652 113.711 134.143 113.119 132.787 113.119H127.478C125.958 113.119 125.662 113.834 125.662 114.623C125.662 116.028 127.462 123.005 134.044 132.226C138.433 138.52 144.612 141.939 150.233 141.939C153.611 141.939 154.022 141.183 154.022 139.876V135.118C154.022 133.598 154.342 133.302 155.41 133.302C156.199 133.302 157.547 133.697 160.695 136.729C164.294 140.328 164.886 141.939 166.915 141.939H172.224C173.744 141.939 174.5 141.183 174.065 139.687C173.588 138.192 171.871 136.03 169.586 133.466C168.345 132.004 166.496 130.426 165.929 129.645C165.14 128.634 165.37 128.182 165.929 127.287C165.921 127.262 172.388 118.157 173.062 115.059Z",
  fill: "white"
});

var SvgCarInFront = function SvgCarInFront(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 298,
    height: 191,
    viewBox: "0 0 298 191",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCarInFront, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car-in-front.bd26ac02.svg";
export { ForwardRef as ReactComponent };